import { render, staticRenderFns } from "./otd-sign.vue?vue&type=template&id=6d3fe958"
import script from "./otd-sign.vue?vue&type=script&lang=ts"
export * from "./otd-sign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports